import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material";

interface UnpinIconProps {
  children?: React.ReactNode;
}

const UnpinIcon: React.FC<UnpinIconProps> = () => {
  const theme = useTheme();
  return (
    <SvgIcon
      sx={{
        fontSize: theme.spacing(2),
        marginRight: theme.spacing(1),
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="unpin"
        data-name="unpin"
        color={theme.palette.primary.main}
        viewBox="0 0 24 24"
      >
        <path d="m14.8721 1.78533c-.3299-.32834-.8469-.37928-1.2351-.12171-1.388.92092-2.0629 2.09001-2.2771 3.22629-.1018.5403-.0972 1.05968-.0269 1.52636l1.6726 1.7772.2795-.27811c.2979-.29649.3718-.74943.1833-1.12445-.1586-.31576-.3055-.89909-.1844-1.54178.0856-.45422.3108-.97196.8219-1.47109l6.0962 6.06696c-.2458.2432-.5454.4793-.8837.6495-.5848.2943-1.2921.4034-2.1541-.0255-.3768-.1875-.8319-.114-1.1299.1825l-.3694.3676 1.4184 1.507c1.1765.3474 2.2486.1448 3.1184-.293 1.018-.5123 1.7455-1.3331 2.1338-1.9127.2588-.38636.2076-.90081-.1223-1.22915zm.0459 13.79937-6.58543-6.58546c-2.71203-.45335-5.01437 1.07646-6.05941 2.00096-.20148.1782-.32018.4313-.3281.6994-.00792.2682.09564.5278.28627.7175l3.963 3.9439-4.03058 4.0446-.66375 2.0944 2.04802-.7168 4.03062-4.0445 3.95156 3.9325c.188.1872.4445.2901.7104.2852.266-.005.5184-.1174.6993-.3115.9429-1.0114 2.4636-3.2022 1.9781-6.0602zm-2.7801 3.9361-7.73266-7.6955c1.17783-.7645 2.88383-1.3728 4.64813-.5857.60995.2721 1.46773.8621 2.13073 1.5219.9709.9662 1.2331 1.4106 1.4937 2.0628.786 1.9674.1868 3.6097-.5399 4.6965z" />
        <path d="m1.29297 2.70718 1.41421-1.41421 20.00002 20.00003-1.4142 1.4142z" />
      </svg>
    </SvgIcon>
  );
};

export default UnpinIcon;
